import Image from "next/image"
import { useId } from "react"

import { cn } from "@/lib/utils"

export function ConvexIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn(
                "size-5 shrink-0 opacity-70 transition-opacity duration-300 group-hover:opacity-100 dark:invert",
                className
            )}
            height={20}
            src="/icons/convex.svg"
            width={20}
        />
    )
}

export function ZedIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn(
                "size-5 shrink-0 opacity-70 invert transition-opacity duration-300 group-hover:opacity-100 dark:invert-0",
                className
            )}
            height={20}
            src="/icons/zed-logo_dark.svg"
            width={20}
        />
    )
}

export function CursorIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Cursor</title>
            <path d="M11.503.131 1.891 5.678a.84.84 0 0 0-.42.726v11.188c0 .3.162.575.42.724l9.609 5.55a1 1 0 0 0 .998 0l9.61-5.55a.84.84 0 0 0 .42-.724V6.404a.84.84 0 0 0-.42-.726L12.497.131a1.01 1.01 0 0 0-.996 0M2.657 6.338h18.55c.263 0 .43.287.297.515L12.23 22.918c-.062.107-.229.064-.229-.06V12.335a.59.59 0 0 0-.295-.51l-9.11-5.257c-.109-.063-.064-.23.061-.23" />
        </svg>
    )
}

export function CodexIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="evenodd"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Codex</title>
            <path
                clipRule="evenodd"
                d="M8.086.457a6.105 6.105 0 013.046-.415c1.333.153 2.521.72 3.564 1.7a.117.117 0 00.107.029c1.408-.346 2.762-.224 4.061.366l.063.03.154.076c1.357.703 2.33 1.77 2.918 3.198.278.679.418 1.388.421 2.126a5.655 5.655 0 01-.18 1.631.167.167 0 00.04.155 5.982 5.982 0 011.578 2.891c.385 1.901-.01 3.615-1.183 5.14l-.182.22a6.063 6.063 0 01-2.934 1.851.162.162 0 00-.108.102c-.255.736-.511 1.364-.987 1.992-1.199 1.582-2.962 2.462-4.948 2.451-1.583-.008-2.986-.587-4.21-1.736a.145.145 0 00-.14-.032c-.518.167-1.04.191-1.604.185a5.924 5.924 0 01-2.595-.622 6.058 6.058 0 01-2.146-1.781c-.203-.269-.404-.522-.551-.821a7.74 7.74 0 01-.495-1.283 6.11 6.11 0 01-.017-3.064.166.166 0 00.008-.074.115.115 0 00-.037-.064 5.958 5.958 0 01-1.38-2.202 5.196 5.196 0 01-.333-1.589 6.915 6.915 0 01.188-2.132c.45-1.484 1.309-2.648 2.577-3.493.282-.188.55-.334.802-.438.286-.12.573-.22.861-.304a.129.129 0 00.087-.087A6.016 6.016 0 015.635 2.31C6.315 1.464 7.132.846 8.086.457zm-.804 7.85a.848.848 0 00-1.473.842l1.694 2.965-1.688 2.848a.849.849 0 001.46.864l1.94-3.272a.849.849 0 00.007-.854l-1.94-3.393zm5.446 6.24a.849.849 0 000 1.695h4.848a.849.849 0 000-1.696h-4.848z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export function FirecrawlIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 50 72"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Firecrawl</title>
            <path
                d="M41.715 23.193c-2.762.82-4.844 2.675-6.37 4.69-.327.432-1.01.107-.88-.423 2.92-12.007-.937-21.986-12.961-26.898a.803.803 0 0 0-1.085.937c5.47 21.961-17.537 20.109-14.63 45.005.05.427-.43.72-.78.47-1.09-.782-2.307-2.415-3.142-3.562a.502.502 0 0 0-.887.16c-.665 2.404-.98 4.67-.98 6.92 0 8.749 4.497 16.45 11.304 20.915.39.255.89-.11.758-.557a13.5 13.5 0 0 1-.563-3.697c0-.788.05-1.593.173-2.343.285-1.885.94-3.68 2.04-5.314 3.772-5.663 11.334-11.132 10.127-18.56-.078-.47.477-.78.827-.457 5.328 4.868 6.383 11.415 5.508 17.287-.075.51.564.782.887.382a11.6 11.6 0 0 1 2.892-2.587c.27-.168.63-.04.733.26.602 1.752 1.497 3.397 2.342 5.042a13.46 13.46 0 0 1 .905 9.982.502.502 0 0 0 .755.57C45.5 66.95 50 59.248 50 50.494c0-3.043-.532-6.025-1.54-8.82-2.112-5.862-7.472-10.264-6.117-17.904.065-.365-.273-.682-.628-.577"
                fill="currentColor"
            />
        </svg>
    )
}

export function JetBrainsIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 256 256"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>JetBrains</title>
            <path d="M0 0h256v256H0z" fill="currentColor" />
            <path
                className="fill-background"
                d="M28 208h96v16H28v-16ZM24 66l7-7c1 2 4 4 6 4 3 0 5-2 5-6V32h11v25c0 5-1 9-4 12-3 2-6 4-10 4h-1c-5 0-10-2-14-6v-1Zm34-34h32v9H69v7h19v8H69v6h21v10H58V32Zm48 10H94V32h35v10h-12v30h-11V42ZM28 88h19c4-1 8 1 11 3 2 2 3 4 3 7 0 4-3 7-7 9 5 1 8 5 8 10 0 7-5 11-15 11H28V88Zm22 12c0-2-2-3-5-3h-6v7h5c4 0 6-1 6-4Zm-4 11h-7v8h7c3 0 5-1 5-4 0-2-1-3-4-3l-1-1Zm43 17-8-12h-4v12H66V88h18c4-1 9 1 13 4 2 2 3 5 3 9 0 6-3 11-8 13l8 11 16-37h10l17 40h-12l-2-7h-16l-3 7H89Zm32-27-5 11h9l-4-11Zm-38-4h-6v10h6c4 0 6-2 6-5s-2-5-6-5Zm62-9h11v40h-11V88Zm15 0h11l14 21V88h11v40h-10l-15-22v22h-11V88Zm38 34 6-8c4 3 8 5 13 5 3 0 4-1 4-3 0-1 0-2-3-3h-3l-1-1h-2l-2-1c-6-1-10-4-10-11s5-13 15-13c6 0 12 2 16 6l-5 7c-3-2-7-4-11-4-3 0-4 1-4 3l3 3h2l2 1c9 2 15 5 15 12 0 8-6 13-15 13h-1c-7 0-13-2-18-5l-1-1Z"
            />
        </svg>
    )
}

export function ManusIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 60 60"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Manus AI</title>
            <path
                clipRule="evenodd"
                d="M9.40053 8.55807C8.88268 9.62143 9.31868 10.9063 10.3744 11.4279C11.8907 12.1771 13.2065 12.9159 14.5094 14.3954C15.2896 15.2815 16.6353 15.3627 17.515 14.5768C18.3947 13.7909 18.4753 12.4354 17.695 11.5493C15.8385 9.441 13.9275 8.40615 12.2497 7.57715C11.194 7.05554 9.91838 7.49471 9.40053 8.55807Z"
                fill="currentColor"
                fillRule="evenodd"
            />
            <path
                clipRule="evenodd"
                d="M20.9079 2.31393C19.7672 2.60119 19.0736 3.76554 19.3588 4.91457C19.558 5.71734 19.7438 6.40375 19.9139 7.03212C20.2395 8.2348 20.5075 9.22481 20.7019 10.4109C20.8934 11.5795 21.9892 12.3704 23.1493 12.1775C24.3095 11.9846 25.0947 10.8809 24.9032 9.71228C24.6735 8.31044 24.3157 6.98407 23.9566 5.65277C23.7976 5.06324 23.6383 4.47275 23.4898 3.87432C23.2046 2.72528 22.0487 2.02667 20.9079 2.31393Z"
                fill="currentColor"
                fillRule="evenodd"
            />
            <path
                clipRule="evenodd"
                d="M33.0786 3.63329C32.0734 3.01888 30.7639 3.34167 30.154 4.35425C29.0225 6.23259 28.4277 8.08208 27.8752 10.308C27.59 11.457 28.2836 12.6213 29.4244 12.9086C30.5651 13.1959 31.7211 12.4973 32.0063 11.3482C32.5183 9.28501 32.9881 7.91768 33.7944 6.5792C34.4044 5.56662 34.0839 4.24769 33.0786 3.63329Z"
                fill="currentColor"
                fillRule="evenodd"
            />
            <path
                clipRule="evenodd"
                d="M43.9331 56.6106C48.0617 53.9722 50.9164 39.8218 50.2884 35.6081C50.2884 35.6081 49.634 33.3459 48.0372 33.3459C46.8137 33.3458 46.1377 34.3405 45.8884 34.8057C45.6728 34.7259 45.4533 34.6537 45.2792 34.5975C45.1853 34.5672 45.0537 34.5253 44.9304 34.4861L44.6964 34.4115C44.5053 34.3503 44.3255 34.2913 44.1561 34.2328L44.1566 34.1728C44.164 32.8051 44.025 30.6709 42.6083 28.4471C42.3816 28.0912 42.1677 27.7731 41.9848 27.5032L41.8701 27.3342C41.734 27.1338 41.6272 26.9765 41.5245 26.8195C41.2723 26.4345 41.2034 26.2861 41.1767 26.2177L41.1755 26.2146C41.1651 26.1881 41.1438 26.1341 41.138 25.9694C41.1309 25.7671 41.1481 25.3842 41.2793 24.7145L41.9612 21.9896L41.9637 21.9756C42.0087 21.7255 42.0491 21.5007 42.0711 21.1346C42.0914 20.7976 42.0956 20.3078 42.01 19.7398C41.8478 18.6638 41.2257 16.6243 39.0332 15.442C38.4974 15.153 37.8556 14.9801 37.2229 14.8974C36.7976 14.8417 36.229 14.8037 35.5687 14.8547C34.2216 14.9587 32.4539 15.4438 30.8803 16.8865L30.4884 17.2987C29.5737 18.4035 28.6076 19.7714 27.8747 20.9819C25.6495 19.9345 23.0302 18.732 21.2001 18.0855C19.1915 17.3759 16.9497 16.7821 14.843 16.8585C12.5099 16.9431 9.88675 17.9212 8.51344 20.6897C7.94928 21.8269 7.70856 23.1551 7.99827 24.5393C8.27511 25.8621 8.95981 26.8738 9.61373 27.5797C10.8279 28.8904 12.4542 29.7023 13.6004 30.1944C14.478 30.5712 15.3797 30.8848 16.178 31.1385C16.0937 31.2911 16.0092 31.4491 15.9278 31.6094C15.6864 32.0841 15.3976 32.7191 15.2075 33.4457C15.0179 34.1702 14.8684 35.2025 15.1387 36.367C15.4161 37.5623 15.965 38.4957 16.6189 39.2096C16.5941 39.5809 16.5848 39.9722 16.5986 40.3769C16.6906 43.0808 18.3417 44.8835 19.7939 45.9057C21.1776 46.8796 22.8071 47.4773 24.1246 47.8792C25.3968 48.2673 26.7402 48.5753 27.8317 48.8255L28.0653 48.8791C29.2286 49.1463 30.3783 49.4555 31.5285 49.7647C32.833 50.1155 34.1381 50.4664 35.4641 50.7565C35.8978 50.8514 36.3192 50.9422 36.7069 51.0249L36.8481 51.393C38.5683 55.7887 40.8651 58.5713 43.9331 56.6106ZM28.2156 38.6193C27.9801 38.5236 27.845 38.4602 27.7251 38.3997C26.6832 37.8576 25.4015 38.2663 24.8596 39.3147C24.3165 40.3653 24.723 41.6609 25.7659 42.2079C25.8514 42.2525 25.9381 42.2945 26.0253 42.3356C26.1714 42.4046 26.3749 42.4963 26.6227 42.597C27.1114 42.7955 27.8062 43.0427 28.5938 43.211C29.9917 43.5097 32.5756 43.7375 34.3274 41.715C35.1684 40.7441 35.5727 39.4684 35.7263 38.2756C35.8845 37.0467 35.8056 35.6985 35.4968 34.3864C34.8887 31.8017 33.2785 28.9733 30.272 27.6319C27.6959 26.4825 25.1502 26.2123 23.0033 26.4547C21.57 26.6166 20.2006 27.0229 19.1006 27.6421V27.5944C16.4105 26.8207 11.0571 25.2808 12.3754 22.6232C13.3748 20.6086 16.1129 20.7751 19.8267 22.0871C21.3351 22.62 23.4312 23.5696 25.4084 24.4956C26.0213 24.7827 26.6228 25.0674 27.1918 25.3369C28.0211 25.7295 29.4076 26.3762 29.4076 26.3762C30.9845 24.47 31.5968 23.42 32.1372 22.4931C32.5089 21.8557 32.8466 21.2765 33.4408 20.5172C34.2818 19.4424 35.6412 18.7782 37.0357 19.1671C38.0076 19.6912 37.7607 21.015 37.7607 21.015L37.0852 23.7141C36.4404 26.8905 37.1541 27.9417 38.3305 29.6741C38.5371 29.9784 38.7581 30.3038 38.9884 30.6653C39.9266 32.1381 39.8833 33.5542 39.8479 34.71C39.8251 35.4534 39.8057 36.0891 40.0528 36.5629C40.5618 37.5387 42.4666 38.1438 43.7154 38.5405C44.0155 38.6358 44.2777 38.7191 44.4736 38.7927L44.6074 38.8457C44.4314 39.3955 44.2715 39.9646 44.1117 40.5332C43.4013 43.0618 42.6941 45.5791 40.5854 46.3334C37.9241 47.2853 35.2627 46.3846 35.2627 46.3846C34.783 46.2434 34.2945 46.1341 33.806 46.0247C33.1971 45.8885 32.588 45.7521 31.9952 45.554C31.1691 45.2451 30.0119 44.9796 28.7543 44.691C25.7598 44.004 22.1958 43.1863 21.1752 41.3406C21.0033 41.0297 20.9035 40.6896 20.8908 40.316C20.8331 38.6187 21.4235 37.099 21.4235 37.099C21.4235 37.099 20.5079 37.1028 19.8658 36.4806C19.6264 36.2487 19.4251 35.9298 19.3233 35.4913C19.12 34.6153 19.2946 33.3456 20.3591 32.2733L20.8926 31.7374C21.1621 31.466 21.961 30.8884 23.4778 30.7171C24.9176 30.5545 26.7 30.7292 28.5474 31.5535C29.9644 32.1857 30.9442 33.6362 31.3534 35.3755C31.5534 36.2255 31.5901 37.0507 31.5034 37.724C31.4121 38.4334 31.211 38.7887 31.1188 38.8952C31.0042 39.0275 30.6006 39.2553 29.4775 39.0153C29.0047 38.9142 28.5556 38.7574 28.2156 38.6193Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    )
}

export function WorkOSIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 55.4 48"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>WorkOS</title>
            <path
                fill="currentColor"
                d="M0,24c0,1.1,0.3,2.1,0.8,3l9.7,16.8c1,1.7,2.5,3.1,4.4,3.7c3.6,1.2,7.5-0.3,9.4-3.5l2.3-4.1l-9.2-16l9.8-16.9L29.5,3c0.7-1.2,1.6-2.2,2.7-3H17.2c-2.6,0-5.1,1.4-6.4,3.7L0.8,21C0.3,21.9,0,22.9,0,24z"
            />
            <path
                fill="currentColor"
                d="M55.4,24c0-1.1-0.3-2.1-0.8-3l-9.8-17c-1.9-3.3-5.8-4.7-9.4-3.5c-1.9,0.6-3.4,2-4.4,3.7L28.7,8L38,24l-9.8,16.9L25.9,45c-0.7,1.2-1.6,2.2-2.7,3h15.1c2.6,0,5.1-1.4,6.4-3.7l10-17.3C55.1,26.1,55.4,25.1,55.4,24z"
            />
        </svg>
    )
}

export function OpenRouterIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>OpenRouter</title>
            <path d="M16.778 1.844v1.919q-.569-.026-1.138-.032-.708-.008-1.415.037c-1.93.126-4.023.728-6.149 2.237-2.911 2.066-2.731 1.95-4.14 2.75-.396.223-1.342.574-2.185.798-.841.225-1.753.333-1.751.333v4.229s.768.108 1.61.333c.842.224 1.789.575 2.185.799 1.41.798 1.228.683 4.14 2.75 2.126 1.509 4.22 2.11 6.148 2.236.88.058 1.716.041 2.555.005v1.918l7.222-4.168-7.222-4.17v2.176c-.86.038-1.611.065-2.278.021-1.364-.09-2.417-.357-3.979-1.465-2.244-1.593-2.866-2.027-3.68-2.508.889-.518 1.449-.906 3.822-2.59 1.56-1.109 2.614-1.377 3.978-1.466.667-.044 1.418-.017 2.278.02v2.176L24 6.014Z" />
        </svg>
    )
}

export function SentryIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 256 227"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Sentry</title>
            <path
                d="M148.368 12.403a23.935 23.935 0 0 0-41.003 0L73.64 70.165c52.426 26.174 87.05 78.177 90.975 136.642h-23.679c-3.918-50.113-34.061-94.41-79.238-116.448l-31.213 53.97a81.595 81.595 0 0 1 47.307 62.375h-54.38a3.895 3.895 0 0 1-3.178-5.69l15.069-25.626a55.046 55.046 0 0 0-17.221-9.738L3.167 191.277a23.269 23.269 0 0 0 8.662 31.982 23.884 23.884 0 0 0 11.583 3.075h74.471a99.432 99.432 0 0 0-41.003-88.72l11.84-20.5c35.679 24.504 55.754 66.038 52.79 109.22h63.094c2.99-65.43-29.047-127.512-84.107-162.986l23.935-41.002a3.947 3.947 0 0 1 5.382-1.384c2.716 1.486 103.993 178.208 105.89 180.258a3.895 3.895 0 0 1-3.486 5.792h-24.396c.307 6.526.307 13.035 0 19.528h24.499A23.528 23.528 0 0 0 256 202.91a23.015 23.015 0 0 0-3.178-11.685L148.368 12.403Z"
                fill="currentColor"
            />
        </svg>
    )
}

export function MicrosoftAzureIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 96 96"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Microsoft Azure</title>
            <path
                d="M33.34 6.54h26.04l-27.03 80.1a4.15 4.15 0 0 1-3.94 2.81H8.15a4.14 4.14 0 0 1-3.93-5.47L29.4 9.38a4.15 4.15 0 0 1 3.94-2.83z"
                fill="currentColor"
            />
            <path
                d="M71.17 60.26H29.88a1.91 1.91 0 0 0-1.3 3.31l26.53 24.76a4.17 4.17 0 0 0 2.85 1.13h23.38z"
                fill="currentColor"
            />
            <path
                d="M33.34 6.54a4.12 4.12 0 0 0-3.95 2.88L4.25 83.92a4.14 4.14 0 0 0 3.91 5.54h20.79a4.44 4.44 0 0 0 3.4-2.9l5.02-14.78 17.91 16.7a4.24 4.24 0 0 0 2.67.97h23.29L71.02 60.26H41.24L59.47 6.55z"
                fill="currentColor"
            />
            <path
                d="M66.6 9.36a4.14 4.14 0 0 0-3.93-2.82H33.65a4.15 4.15 0 0 1 3.93 2.82l25.18 74.62a4.15 4.15 0 0 1-3.93 5.48h29.02a4.15 4.15 0 0 0 3.93-5.48z"
                fill="currentColor"
            />
        </svg>
    )
}

export function OpenCodeIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 512 512"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>OpenCode</title>
            <path
                d="M320 224V352H192V224H320Z"
                fill="currentColor"
                fillOpacity={0.38}
            />
            <path
                clipRule="evenodd"
                d="M384 416H128V96H384V416ZM320 160H192V352H320V160Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    )
}

export function GhosttyIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 27 32"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Ghostty</title>
            <path
                d="M20.395 32a6.35 6.35 0 0 1-3.516-1.067A6.355 6.355 0 0 1 13.362 32c-1.249 0-2.48-.375-3.516-1.067A6.265 6.265 0 0 1 6.372 32h-.038a6.255 6.255 0 0 1-4.5-1.906 6.377 6.377 0 0 1-1.836-4.482v-12.25C0 5.995 5.994 0 13.362 0c7.369 0 13.363 5.994 13.363 13.363v12.253c0 3.393-2.626 6.192-5.978 6.375-.117.007-.234.009-.352.009Z"
                fill="currentColor"
            />
            <path
                d="M20.395 30.593a4.932 4.932 0 0 1-3.08-1.083.656.656 0 0 0-.42-.145.784.784 0 0 0-.487.176 4.939 4.939 0 0 1-3.046 1.055 4.939 4.939 0 0 1-3.045-1.055.751.751 0 0 0-.942 0 4.883 4.883 0 0 1-3.01 1.055h-.033a4.852 4.852 0 0 1-3.49-1.482 4.982 4.982 0 0 1-1.436-3.498V13.367c0-6.597 5.364-11.96 11.957-11.96 6.592 0 11.956 5.363 11.956 11.956v12.253c0 2.645-2.042 4.827-4.65 4.97a5.342 5.342 0 0 1-.274.007Z"
                fill="currentColor"
            />
            <path
                className="fill-background"
                d="M23.912 13.363v12.253c0 1.876-1.447 3.463-3.32 3.566a3.503 3.503 0 0 1-2.398-.769c-.778-.626-1.873-.598-2.658.021a3.5 3.5 0 0 1-2.176.753 3.494 3.494 0 0 1-2.173-.753 2.153 2.153 0 0 0-2.684 0 3.498 3.498 0 0 1-2.15.753c-1.948.014-3.54-1.627-3.54-3.575v-12.25c0-5.825 4.724-10.549 10.55-10.549 5.825 0 10.549 4.724 10.549 10.55Z"
            />
            <path
                d="m11.28 12.437-3.93-2.27a1.072 1.072 0 0 0-1.463.392 1.072 1.072 0 0 0 .391 1.463l2.326 1.343-2.326 1.343a1.072 1.072 0 0 0 1.071 1.855l3.932-2.27a1.071 1.071 0 0 0 0-1.854v-.002ZM20.182 12.291h-5.164a1.071 1.071 0 1 0 0 2.143h5.164a1.071 1.071 0 1 0 0-2.143Z"
                fill="currentColor"
            />
        </svg>
    )
}

export function PlaywrightIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 400 400"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Playwright</title>
            <path
                d="M136.444 221.556C123.558 225.213 115.104 231.625 109.535 238.032C114.869 233.364 122.014 229.08 131.652 226.348C141.51 223.554 149.92 223.574 156.869 224.915V219.481C150.941 218.939 144.145 219.371 136.444 221.556ZM108.946 175.876L61.0895 188.484C61.0895 188.484 61.9617 189.716 63.5767 191.36L104.153 180.668C104.153 180.668 103.578 188.077 98.5847 194.705C108.03 187.559 108.946 175.876 108.946 175.876ZM149.005 288.347C81.6582 306.486 46.0272 228.438 35.2396 187.928C30.2556 169.229 28.0799 155.067 27.5 145.928C27.4377 144.979 27.4665 144.179 27.5336 143.446C24.04 143.657 22.3674 145.473 22.7077 150.721C23.2876 159.855 25.4633 174.016 30.4473 192.721C41.2301 233.225 76.8659 311.273 144.213 293.134C158.872 289.185 169.885 281.992 178.152 272.81C170.532 279.692 160.995 285.112 149.005 288.347ZM161.661 128.11V132.903H188.077C187.535 131.206 186.989 129.677 186.447 128.11H161.661Z"
                fill="currentColor"
            />
            <path
                d="M193.981 167.584C205.861 170.958 212.144 179.287 215.465 186.658L228.711 190.42C228.711 190.42 226.904 164.623 203.57 157.995C181.741 151.793 168.308 170.124 166.674 172.496C173.024 167.972 182.297 164.268 193.981 167.584ZM299.422 186.777C277.573 180.547 264.145 198.916 262.535 201.255C268.89 196.736 278.158 193.031 289.837 196.362C301.698 199.741 307.976 208.06 311.307 215.436L324.572 219.212C324.572 219.212 322.736 193.41 299.422 186.777ZM286.262 254.795L176.072 223.99C176.072 223.99 177.265 230.038 181.842 237.869L274.617 263.805C282.255 259.386 286.262 254.795 286.262 254.795ZM209.867 321.102C122.618 297.71 133.166 186.543 147.284 133.865C153.097 112.156 159.073 96.0203 164.029 85.204C161.072 84.5953 158.623 86.1529 156.203 91.0746C150.941 101.747 144.212 119.124 137.7 143.45C123.586 196.127 113.038 307.29 200.283 330.682C241.406 341.699 273.442 324.955 297.323 298.659C274.655 319.19 245.714 330.701 209.867 321.102Z"
                fill="currentColor"
            />
            <path
                d="M161.661 262.296V239.863L99.3324 257.537C99.3324 257.537 103.938 230.777 136.444 221.556C146.302 218.762 154.713 218.781 161.661 220.123V128.11H192.869C189.471 117.61 186.184 109.526 183.423 103.909C178.856 94.612 174.174 100.775 163.545 109.665C156.059 115.919 137.139 129.261 108.668 136.933C80.1966 144.61 57.179 142.574 47.5752 140.911C33.9601 138.562 26.8387 135.572 27.5049 145.928C28.0847 155.062 30.2605 169.224 35.2445 187.928C46.0272 228.433 81.663 306.481 149.01 288.342C166.602 283.602 179.019 274.233 187.626 262.291H161.661V262.296ZM61.0848 188.484L108.946 175.876C108.946 175.876 107.551 194.288 89.6087 199.018C71.6614 203.743 61.0848 188.484 61.0848 188.484Z"
                fill="currentColor"
            />
            <path
                d="M341.786 129.174C329.345 131.355 299.498 134.072 262.612 124.185C225.716 114.304 201.236 97.0224 191.537 88.8994C177.788 77.3834 171.74 69.3802 165.788 81.4857C160.526 92.163 153.797 109.54 147.284 133.866C133.171 186.543 122.623 297.706 209.867 321.098C297.093 344.47 343.53 242.92 357.644 190.238C364.157 165.917 367.013 147.5 367.799 135.625C368.695 122.173 359.455 126.078 341.786 129.174ZM166.497 172.756C166.497 172.756 180.246 151.372 203.565 158C226.899 164.628 228.706 190.425 228.706 190.425L166.497 172.756ZM223.42 268.713C182.403 256.698 176.077 223.99 176.077 223.99L286.262 254.796C286.262 254.791 264.021 280.578 223.42 268.713ZM262.377 201.495C262.377 201.495 276.107 180.126 299.422 186.773C322.736 193.411 324.572 219.208 324.572 219.208L262.377 201.495Z"
                fill="currentColor"
            />
            <path
                d="M139.88 246.04L99.3324 257.532C99.3324 257.532 103.737 232.44 133.607 222.496L110.647 136.33L108.663 136.933C80.1918 144.611 57.1742 142.574 47.5704 140.911C33.9554 138.563 26.834 135.572 27.5001 145.929C28.08 155.063 30.2557 169.224 35.2397 187.929C46.0225 228.433 81.6583 306.481 149.005 288.342L150.989 287.719L139.88 246.04ZM61.0848 188.485L108.946 175.876C108.946 175.876 107.551 194.288 89.6087 199.018C71.6615 203.743 61.0848 188.485 61.0848 188.485Z"
                fill="currentColor"
            />
            <path
                d="M225.27 269.163L223.415 268.712C182.398 256.698 176.072 223.99 176.072 223.99L232.89 239.872L262.971 124.281L262.607 124.185C225.711 114.304 201.232 97.0224 191.532 88.8994C177.783 77.3834 171.735 69.3802 165.783 81.4857C160.526 92.163 153.797 109.54 147.284 133.866C133.171 186.543 122.623 297.706 209.867 321.097L211.655 321.5L225.27 269.163ZM166.497 172.756C166.497 172.756 180.246 151.372 203.565 158C226.899 164.628 228.706 190.425 228.706 190.425L166.497 172.756Z"
                fill="currentColor"
            />
            <path
                d="M141.946 245.451L131.072 248.537C133.641 263.019 138.169 276.917 145.276 289.195C146.513 288.922 147.74 288.687 149 288.342C152.302 287.451 155.364 286.348 158.312 285.145C150.371 273.361 145.118 259.789 141.946 245.451ZM137.7 143.451C132.112 164.307 127.113 194.326 128.489 224.436C130.952 223.367 133.554 222.371 136.444 221.551L138.457 221.101C136.003 188.939 141.308 156.165 147.284 133.866C148.799 128.225 150.318 122.978 151.832 118.085C149.393 119.637 146.767 121.228 143.776 122.867C141.759 129.093 139.722 135.898 137.7 143.451Z"
                fill="currentColor"
            />
        </svg>
    )
}

export function McpIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>ModelContextProtocol</title>
            <path d="M15.688 2.343a2.588 2.588 0 00-3.61 0l-9.626 9.44a.863.863 0 01-1.203 0 .823.823 0 010-1.18l9.626-9.44a4.313 4.313 0 016.016 0 4.116 4.116 0 011.204 3.54 4.3 4.3 0 013.609 1.18l.05.05a4.115 4.115 0 010 5.9l-8.706 8.537a.274.274 0 000 .393l1.788 1.754a.823.823 0 010 1.18.863.863 0 01-1.203 0l-1.788-1.753a1.92 1.92 0 010-2.754l8.706-8.538a2.47 2.47 0 000-3.54l-.05-.049a2.588 2.588 0 00-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 01-1.204 0 .823.823 0 010-1.18l7.273-7.133a2.47 2.47 0 00-.003-3.537z" />
            <path d="M14.485 4.703a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a4.115 4.115 0 000 5.9 4.314 4.314 0 006.016 0l7.12-6.982a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a2.588 2.588 0 01-3.61 0 2.47 2.47 0 010-3.54l7.12-6.982z" />
        </svg>
    )
}

export function CloudflareIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 256 116"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Cloudflare</title>
            <path
                className="fill-background"
                d="m202.357 49.394-5.311-2.124C172.085 103.434 72.786 69.289 66.81 85.997c-.996 11.286 54.227 2.146 93.706 4.059 12.039.583 18.076 9.671 12.964 24.484l10.069.031c11.615-36.209 48.683-17.73 50.232-29.68-2.545-7.857-42.601 0-31.425-35.497Z"
            />
            <path
                fill="currentColor"
                d="M176.332 108.348c1.593-5.31 1.062-10.622-1.593-13.809-2.656-3.187-6.374-5.31-11.154-5.842L71.17 87.634c-.531 0-1.062-.53-1.593-.53-.531-.532-.531-1.063 0-1.594.531-1.062 1.062-1.594 2.124-1.594l92.946-1.062c11.154-.53 22.839-9.56 27.087-20.182l5.312-13.809c0-.532.531-1.063 0-1.594C191.203 20.182 166.772 0 138.091 0 111.535 0 88.697 16.995 80.73 40.896c-5.311-3.718-11.684-5.843-19.12-5.31-12.747 1.061-22.838 11.683-24.432 24.43-.531 3.187 0 6.374.532 9.56C16.996 70.107 0 87.103 0 108.348c0 2.124 0 3.718.531 5.842 0 1.063 1.062 1.594 1.594 1.594h170.489c1.062 0 2.125-.53 2.125-1.594l1.593-5.842Z"
            />
            <path
                fill="currentColor"
                d="M205.544 48.863h-2.656c-.531 0-1.062.53-1.593 1.062l-3.718 12.747c-1.593 5.31-1.062 10.623 1.594 13.809 2.655 3.187 6.373 5.31 11.153 5.843l19.652 1.062c.53 0 1.062.53 1.593.53.53.532.53 1.063 0 1.594-.531 1.063-1.062 1.594-2.125 1.594l-20.182 1.062c-11.154.53-22.838 9.56-27.087 20.182l-1.063 4.78c-.531.532 0 1.594 1.063 1.594h70.108c1.062 0 1.593-.531 1.593-1.593 1.062-4.25 2.124-9.03 2.124-13.81 0-27.618-22.838-50.456-50.456-50.456"
            />
        </svg>
    )
}

/** Custom mark: rounded canvas + freehand stroke (TLDraw-style whiteboard). */
export function TLDrawIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>TLDraw</title>
            <rect
                x="3.5"
                y="4.5"
                width="17"
                height="15"
                rx="2"
                ry="2"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M7 14.5c1.8-2.8 3.8-3.2 6-1.2 2.2 2 4.5 1.8 7.5-.8"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                d="M8 10.5c2-1.2 3.5-.8 4.8.6"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </svg>
    )
}

export function CanvaIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Canva</title>
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM6.962 7.68c.754 0 1.337.549 1.405 1.2.069.583-.171 1.097-.822 1.406-.343.171-.48.172-.549.069-.034-.069 0-.137.069-.206.617-.514.617-.926.548-1.508-.034-.378-.308-.618-.583-.618-1.2 0-2.914 2.674-2.674 4.629.103.754.549 1.646 1.509 1.646.308 0 .65-.103.96-.24.5-.264.799-.47 1.097-.8-.073-.885.704-2.046 1.851-2.046.515 0 .926.205.96.583.068.514-.377.582-.514.582s-.378-.034-.378-.17c-.034-.138.309-.07.275-.378-.035-.206-.24-.274-.446-.274-.72 0-1.131.994-1.029 1.611.035.275.172.549.447.549.205 0 .514-.31.617-.755.068-.308.343-.514.583-.514.102 0 .17.034.205.171v.138c-.034.137-.137.548-.102.651 0 .069.034.171.17.171.092 0 .436-.18.777-.459.117-.59.253-1.298.253-1.357.034-.24.137-.48.617-.48.103 0 .171.034.205.171v.138l-.136.617c.445-.583 1.097-.994 1.508-.994.172 0 .309.102.309.274 0 .103 0 .274-.069.446-.137.377-.309.96-.412 1.474 0 .137.035.274.207.274.171 0 .685-.206 1.096-.754l.007-.004c-.002-.068-.007-.134-.007-.202 0-.411.035-.754.104-.994.068-.274.411-.514.617-.514.103 0 .205.069.205.171 0 .035 0 .103-.034.137-.137.446-.24.857-.24 1.269 0 .24.034.582.102.788 0 .034.035.069.07.069.068 0 .548-.445.89-1.028-.308-.206-.48-.549-.48-.96 0-.72.446-1.097.858-1.097.343 0 .617.24.617.72 0 .308-.103.65-.274.96h.102a.77.77 0 0 0 .584-.24.293.293 0 0 1 .134-.117c.335-.425.83-.74 1.41-.74.48 0 .924.205.959.582.068.515-.378.618-.515.618l-.002-.002c-.138 0-.377-.035-.377-.172 0-.137.309-.068.274-.376-.034-.206-.24-.275-.446-.275-.686 0-1.13.891-1.028 1.611.034.275.171.583.445.583.206 0 .515-.308.652-.754.068-.274.343-.514.583-.514.103 0 .17.034.205.171 0 .069 0 .206-.137.652-.17.308-.171.48-.137.617.034.274.171.48.309.583.034.034.068.102.068.102 0 .069-.034.138-.137.138-.034 0-.068 0-.103-.035-.514-.205-.72-.548-.789-.891-.205.24-.445.377-.72.377-.445 0-.89-.411-.96-.926a1.609 1.609 0 0 1 .075-.649c-.203.13-.422.203-.623.203h-.17c-.447.652-.927 1.098-1.27 1.303a.896.896 0 0 1-.377.104c-.068 0-.171-.035-.205-.104-.095-.152-.156-.392-.193-.667-.481.527-1.145.805-1.453.805-.343 0-.548-.206-.582-.55v-.376c.102-.754.377-1.2.377-1.337a.074.074 0 0 0-.069-.07c-.24 0-1.028.824-1.166 1.373l-.103.445c-.068.309-.377.515-.582.515-.103 0-.172-.035-.206-.172v-.137l.046-.233c-.435.31-.87.508-1.075.508-.308 0-.48-.172-.514-.412-.206.274-.445.412-.754.412-.352 0-.696-.24-.862-.593-.244.275-.523.553-.852.764-.48.309-1.028.549-1.68.549-.582 0-1.097-.309-1.371-.583-.412-.377-.651-.96-.686-1.509-.205-1.68.823-3.84 2.4-4.8.378-.205.755-.343 1.132-.343zm9.77 3.291c-.104 0-.172.172-.172.343 0 .274.137.583.309.755a1.74 1.74 0 0 0 .102-.583c0-.343-.137-.515-.24-.515z" />
        </svg>
    )
}

export function OpenAIIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>OpenAI</title>
            <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
        </svg>
    )
}

export function RelumeIcon({ className }: { className?: string }) {
    const gradientId = useId()

    return (
        <svg
            role="img"
            viewBox="0 0 32 32"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Relume</title>
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                >
                    <stop offset="0%" stopColor="#FF4D4D" />
                    <stop offset="50%" stopColor="#F43F5E" />
                    <stop offset="100%" stopColor="#7C3AED" />
                </linearGradient>
            </defs>
            <circle
                cx="16"
                cy="16"
                r="13.5"
                fill="#0A0A0A"
                stroke={`url(#${gradientId})`}
                strokeWidth="2"
            />
            <path
                d="M16 8.5L21.8 11.8L16 15.2L10.2 11.8L16 8.5Z"
                fill="#FFFFFF"
                stroke="#0A0A0A"
                strokeWidth="0.75"
                strokeLinejoin="round"
            />
            <path
                d="M10.2 11.8L16 15.2V22L10.2 18.6V11.8Z"
                fill="#111111"
                stroke="#333333"
                strokeWidth="0.5"
                strokeLinejoin="round"
            />
            <path
                d="M16 15.2L21.8 11.8V18.6L16 22V15.2Z"
                fill="#FFFFFF"
                stroke="#0A0A0A"
                strokeWidth="0.75"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export function ZAIIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 30 30"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Z.ai</title>
            <path
                fill="#2D2D2D"
                stroke="rgba(255,255,255,0.25)"
                strokeWidth="0.6317"
                d="M24.51 28.51H5.49c-2.21 0-4-1.79-4-4V5.49c0-2.21 1.79-4 4-4h19.03c2.21 0 4 1.79 4 4v19.03c0 2.22-1.79 4.01-4.02 4.01z"
            />
            <path
                fill="#FFFFFF"
                d="M15.47 7.1l-1.3 1.85c-.2.29-.54.47-.9.47h-7.1V7.09h9.3z"
            />
            <polygon
                fill="#FFFFFF"
                points="24.3 7.1 13.14 22.91 5.7 22.91 16.86 7.1"
            />
            <path
                fill="#FFFFFF"
                d="M14.53 22.91l1.31-1.86c.2-.29.54-.47.9-.47h7.09v2.33h-9.3z"
            />
        </svg>
    )
}

export function SVGLIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={className}
            height={20}
            src="/icons/svgl.svg"
            width={20}
        />
    )
}

export function FontshareIcon({ className }: { className?: string }) {
    return (
        <>
            <Image
                alt=""
                className={cn(className, "dark:hidden")}
                height={20}
                src="/icons/fontshare.svg"
                width={20}
            />
            <Image
                alt=""
                className={cn(className, "hidden dark:block")}
                height={20}
                src="/icons/fontshare_dark.svg"
                width={20}
            />
        </>
    )
}

export function DribbbleIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={className}
            height={20}
            src="/icons/dribbble.svg"
            width={20}
        />
    )
}

export function PinterestIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={className}
            height={20}
            src="/icons/pinterest.svg"
            width={20}
        />
    )
}

export function NvidiaIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={className}
            height={20}
            src="/icons/nvidia.svg"
            width={20}
        />
    )
}

export function CoolorsIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/coolors.webp"
            width={22}
        />
    )
}

export function MosIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/mos.webp"
            width={22}
        />
    )
}

export function HandyIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/handy.webp"
            width={22}
        />
    )
}

export function MoleIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn(
                "object-contain dark:brightness-0 dark:invert",
                className
            )}
            height={15}
            src="/icons/mole.webp"
            width={23}
        />
    )
}

export function EmilSkillsIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/emil-skills.webp"
            width={22}
        />
    )
}

export function SkillsShIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn(
                "rounded-full border border-border/40 object-contain",
                className
            )}
            height={22}
            src="/icons/skills-sh.webp"
            width={22}
        />
    )
}

export function TwentyFirstIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/21st.webp"
            width={22}
        />
    )
}

export function ReactBitsIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-full object-contain", className)}
            height={22}
            src="/icons/reactbits.webp"
            width={22}
        />
    )
}

export function MagicUIIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-full object-contain", className)}
            height={22}
            src="/icons/magicui.webp"
            width={22}
        />
    )
}

export function AceternityIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/aceternity.webp"
            width={22}
        />
    )
}

export function MotionPrimitivesIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("object-contain dark:invert", className)}
            height={15}
            src="/icons/motion-primitives.webp"
            width={22}
        />
    )
}

export function MotionDevIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/motion.webp"
            width={22}
        />
    )
}

export function LogoipsumIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("object-contain", className)}
            height={20}
            src="/icons/logoipsum.svg"
            unoptimized
            width={20}
        />
    )
}

export function ArcIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/arc.webp"
            width={22}
        />
    )
}

export function DiaIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/dia.webp"
            width={22}
        />
    )
}

export function AntigravityIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/antigravity.webp"
            width={22}
        />
    )
}

export function ShottrIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/shottr.webp"
            width={22}
        />
    )
}

export function StatsIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/stats.webp"
            width={22}
        />
    )
}

export function MaccyIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/maccy.webp"
            width={22}
        />
    )
}

export function CapIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={20}
            src="/icons/cap.svg"
            unoptimized
            width={20}
        />
    )
}

export function FontsNinjaIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("object-contain", className)}
            height={22}
            src="/icons/fonts-ninja.webp"
            width={22}
        />
    )
}

export function GoogleTranslateIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/google-translate.webp"
            width={22}
        />
    )
}

export function GridLinesRulerIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/grid-lines-ruler.webp"
            width={22}
        />
    )
}

export function ProtonVPNIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("object-contain", className)}
            height={22}
            src="/icons/proton-vpn.webp"
            width={22}
        />
    )
}

export function WappalyzerIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/wappalyzer.webp"
            width={22}
        />
    )
}

export function ICloudPasswordsIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/icloud-passwords.webp"
            width={22}
        />
    )
}

export function UBlockOriginIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("object-contain", className)}
            height={22}
            src="/icons/ublock-origin-lite.webp"
            width={22}
        />
    )
}

export function CobaltIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/cobalt.webp"
            width={22}
        />
    )
}

export function AffinityIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/affinity.webp"
            width={22}
        />
    )
}

export function BrunoIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("object-contain", className)}
            height={22}
            src="/icons/bruno.webp"
            width={22}
        />
    )
}

export function SoroIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/soro.webp"
            width={22}
        />
    )
}

export function JSONForgeIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn("rounded-[4px] object-contain", className)}
            height={22}
            src="/icons/json-forge.svg"
            unoptimized
            width={22}
        />
    )
}

export function MobbinIcon({ className }: { className?: string }) {
    return (
        <Image
            alt=""
            className={cn(
                "rounded-[4px] border border-border/40 object-contain",
                className
            )}
            height={22}
            src="/icons/mobbin.webp"
            unoptimized
            width={22}
        />
    )
}

export function ElevenLabsIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>ElevenLabs</title>
            <path d="M4.6035 0v24h4.9317V0zm9.8613 0v24h4.9317V0z" />
        </svg>
    )
}

export function InsporaIcon({ className }: { className?: string }) {
    return (
        <svg
            role="img"
            viewBox="8 10 48 44"
            fill="currentColor"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Inspora</title>
            <path d="M8 54V10h27.5C46.82 10 56 19.18 56 30.5V54H41.5V32c0-4.14-3.36-7.5-7.5-7.5H22.5V54H8Z" />
        </svg>
    )
}
